import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { t } from 'src/shared/literals';
import Datatable from '../../../shared/ui/components/Datatable';
import getCustomerContactList from 'src/customer-contact/use-cases/getCustomerContactList';

const CustomerContactDatatable = ({ customerId, handleEdit, handleAdd }) => {
  const [list, setList] = useState({
    rows: [],
    count: 0
  });
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState({
    columnName: null,
    orderBy: null
  });

  const navigate = useNavigate();

  const fetchList = async () => {
    const response = await getCustomerContactList({
      headquarterCustomerId: customerId,
      search,
      orderBy: orderBy.columnName
        ? `${orderBy.columnName} ${orderBy.orderBy}`
        : '',
      page,
      limit
    });

    response.rows = response.rows.map((x) => {
      let PaymentTypeList = {
        PaymentTypeList: x.PaymentTypeList
          ? x.PaymentTypeList.map((y) => t(y.toLowerCase()).toUpperCase()).join(
              ','
            )
          : ''
      };

      return {
        ...x,
        ...PaymentTypeList
      };
    });

    setList(response);
  };

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    fetchList();
  }, [page, limit, search, orderBy]);

  const handleSearch = (searchValue) => {
    setPage(0);
    setSearch(searchValue.target.value);
  };

  const handleChangePage = (pageIndex) => {
    setPage(pageIndex);
  };

  const handleChangeLimit = (limitIndex) => {
    setLimit(limitIndex);
  };

  const handleOrderBy = (column) => {
    setOrderBy(column);
  };

  const handleClickEdit = (event, id) => {
    handleEdit(id);
  };

  const handleClickAdd = (event) => {
    handleAdd();
  };

  const columnNameList = [
    'createdAt',
    'relationship',
    'firstname',
    'surnames',
    'zoneCode',
    'document',
    'phone1',
    'balance',
    'PaymentTypeList',
    'preferredPaymentDay',
    'email'
  ];

  return (
    <Datatable
      domainName="CUSTOMER_CONTACT"
      dataList={list.rows}
      count={list.count}
      addButtonText="Añadir contacto"
      addButtonRoute={false}
      title="Contactos"
      exportExcelButton={Boolean(false)}
      onSearch={handleSearch}
      onChangePageValue={handleChangePage}
      onChangePageLimit={handleChangeLimit}
      handleOrderBy={handleOrderBy}
      handleClickAdd={handleClickAdd}
      handleClickEdit={handleClickEdit}
      columnNameList={columnNameList}
    />
  );
};

export default CustomerContactDatatable;
